import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentToken: null,
        status: null,
        userLogged: {},
        assinaturas : [],

        dialogLoaderMain : false,

        dialogRecoverPwd : false,

        myTotalTreinoCount : 0,
    },
    mutations: {
        addToken(state, val) {
            state.currentToken = val;
            state.status = 'success';
        },
        logout(state) {
            state.currentToken = null;
            
            //removendo local storage:
            var storage = window.localStorage;
            storage.removeItem('username');
            storage.removeItem('password');

            state.status = 'logout';
            state.userLogged = {};
        },
        addUserLogged(state, user){
            state.userLogged = user;
        },
        setLoader(state, show){
            state.dialogLoaderMain = show;
        },
        updateProfile(state, profile){
            state.userLogged.profile = profile;
        },
        updateAssinaturas(state, assinaturas){
            state.assinaturas = assinaturas;
        },
        setDialogRecoverPwd(state, dialogRecoverPwd){
            state.dialogRecoverPwd = dialogRecoverPwd;
        },
        setMyTotalTreinoCount(state, myTotalTreinoCount){
            state.myTotalTreinoCount = myTotalTreinoCount;
        }
    },
    getters: {
        isAuthenticated: state => !!state.currentToken,
        authStatus: state => state.status,
        userLogged : state => state.userLogged,
        dialogLoaderMain : state => state.dialogLoaderMain,
        assinaturas : state => state.assinaturas,
        dialogRecoverPwd : state => state.dialogRecoverPwd,
        myTotalTreinoCount : state => state.myTotalTreinoCount,
    }
})  